export interface UpdateReserveGroupReserveRequest {
  userId: string
  reserveGroupId: number
  reserves: {
    id: number
    bibliographyRealId: number
    revision: number
  }[]
}

export function UpdateReserveGroupReserveRequestToJSON(
  value: UpdateReserveGroupReserveRequest
): any {
  return {
    user_id: value.userId !== '' ? value.userId : undefined,
    reserve_group_id:
      value.reserveGroupId !== 0 ? value.reserveGroupId : undefined,
    reserves:
      value.reserves.length > 0
        ? value.reserves.map(reserve => {
            return {
              id: reserve.id !== 0 ? reserve.id : undefined,
              bibliography_real_id:
                reserve.bibliographyRealId !== 0
                  ? reserve.bibliographyRealId
                  : undefined,
              revision: reserve.revision !== 0 ? reserve.revision : undefined
            }
          })
        : []
  }
}
